import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=5feb71be&"
import script from "./Inspector.vue?vue&type=script&lang=ts&"
export * from "./Inspector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports